
import { ReactNode } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Building2, ArrowLeft } from "lucide-react";

interface InternalLayoutProps {
  children: ReactNode;
  title: string;
  subtitle?: string;
  showBackButton?: boolean;
  backPath?: string;
}

const InternalLayout = ({ 
  children, 
  title, 
  subtitle, 
  showBackButton = false, 
  backPath = "/" 
}: InternalLayoutProps) => {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-gradient-to-br from-juv-cream-white to-white font-juv-body">
      {/* Header */}
      <div className="bg-gradient-to-r from-white to-juv-soft-blush border-b border-juv-rose-clay/20">
        <div className="container mx-auto px-6 py-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              {showBackButton && (
                <Link to={backPath}>
                  <Button 
                    variant="ghost" 
                    size="sm"
                    className="text-juv-deep-chestnut hover:bg-juv-soft-blush/50"
                  >
                    <ArrowLeft className="h-4 w-4 mr-2" />
                    Back
                  </Button>
                </Link>
              )}
              <div className="w-12 h-12 bg-juv-gradient-primary rounded-full flex items-center justify-center">
                <Building2 className="h-6 w-6 text-white" />
              </div>
              <div>
                <h1 className="text-3xl font-bold text-juv-deep-chestnut font-juv-heading">{title}</h1>
                {subtitle && <p className="text-juv-deep-chestnut/70 mt-1">{subtitle}</p>}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-6 py-8">
        {children}
      </div>
    </div>
  );
};

export default InternalLayout;
